export default "__VITE_ASSET__SKxn3frQ__"